import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsIntroductionBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">API Reference</div>
          <div className="text">
            Canny's API lets you access and modify your Canny data programmatically. We also support
            webhooks, where we notify your server of events as they&nbsp;happen.
          </div>
          <div className="text">
            The API expects the request to use the POST HTTP method, the body as JSON, and the
            Content-Type header set to "application/json".
          </div>
          <div className="text">
            This API enables you to seamlessly integrate Canny with your existing&nbsp;services.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
